import globals from "../partials/global-variables";
import { NormalText } from "../partials/texts";

export default {
  container: {
    display: "block",
    ...NormalText,
    top: "-10px",
    left: "50%",
    transform: "translate(-84%,-100%)",
    padding: "14px 20px",
    color: "red",
    backgroundColor: globals.colors.white,
    borderRadius: "8px",
    position: "absolute",
    zIndex: "100",
    boxSizing: "border-box",
    boxShadow: "0 0 5px 0 rgba(0,0,0,.5)",
    transition: "opacity ease .5s",
    width: "150px",
    visibility: "hidden",
    [`@media (${globals.breakpoints.$md})`]: {
      transform: "translate(-50%,-100%)"
    },
    "& i": {
      position: "absolute",
      top: "100%",
      left: "84%",
      marginLeft: "-10px",
      width: "20px",
      height: "10px",
      overflow: "hidden",
      [`@media (${globals.breakpoints.$md})`]: {
        left: "50%"
      },
      "&:after": {
        content: "''",
        position: "absolute",
        width: "10px",
        height: "10px",
        left: "50%",
        transform: "translate(-50%,-50%) rotate(45deg)",
        backgroundColor: globals.colors.white,
        boxShadow: "0 1px 5px -1px rgba(0,0,0,.5)"
      }
    }
  }
};
